import { notification } from 'antd';
import React, { FunctionComponent, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Form from '../../components/Form';
import { Button } from '../../components/inputs/button';
import { useAuthStore } from '../../store/auth-store';
import { FieldType } from '../../types';

/**
 * AccountVerifyPage props
 */
interface Props {}

/**
 * AccountVerifyPage Component
 */
const AccountVerifyPage: FunctionComponent<Props> = () => {
  const { state } = useLocation();
  const { resendCode, resendCodeState } = useAuthStore();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (!state || !state.email) {
      navigate('/auth/login');
    }
  }, [navigate, state]);

  const onSubmitCapture = useCallback(() => {
    //   resendCode(data as { email: string });
  }, []);

  const resendVerificationCode = useCallback(async () => {
    await resendCode({ email: state.email });
    api.success({ message: 'Code resent!' });
  }, [api, resendCode, state.email]);

  return (
    <div>
      {contextHolder}
      <h4 className="text-3xl mb-3 text-blue">Verify Account</h4>
      <h4 className="text-xl mb-2">Enter one-time code</h4>
      <span className="text-base">
        We will send a one-time code via email. Please check your email and copy
        and paste the code below.
      </span>
      <Form
        fields={[
          { key: 'code', required: true },
          {
            key: 'resendCode',
            type: FieldType.Custom,
            hasLabel: false,
            className: 'mb-1',
            render() {
              return (
                <Button
                  onClick={resendVerificationCode}
                  loading={resendCodeState.isLoading}
                  colorClassname="white"
                  className="text-red font-semibold w-full">
                  Resend Code
                </Button>
              );
            },
          },
        ]}
        formProps={{ onSubmitCapture }}
        submitButtonProps={{ loading: resendCodeState.isLoading }}
      />
    </div>
  );
};

export default AccountVerifyPage;
